(function () {
  'use strict';

  var API_URL = 'https://script.google.com/macros/s/AKfycbzFRwcpXroQjUlvPz_KSyeUMxf18CrLqi_d5yH44lV6hyxs9_p7GJkykL0eq48-SIHaFw/exec';

  var session = null;
  var adminMaster = '';
  var buttons = [];
  var adminUsers = [];
  var adminButtons = [];
  var settings = { lockEnabled: true };
  var DEFAULT_BUTTONS = [
    { id: 'req', label: 'Requisicion', url: 'https://www.lienzolibreria.com.mx/pages/requisicion' },
    { id: 'roles', label: 'Roles', url: 'https://www.lienzolibreria.com.mx/pages/roldeaseo' },
    { id: 'horarios', label: 'Horarios', url: 'https://www.lienzolibreria.com.mx/pages/nomhor' }
  ];

  function $(id) {
    return document.getElementById(id);
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"]/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[char];
    });
  }

  function escAttr(value) {
    return String(value == null ? '' : value).replace(/\\/g, '\\\\').replace(/'/g, "\\'");
  }

  function bind(id, eventName, handler) {
    var el = $(id);
    if (el) el.addEventListener(eventName || 'click', handler);
  }

  function setButtonBusy(id, busy, label) {
    var el = $(id);
    if (!el) return;
    if (!el._defaultText) el._defaultText = el.textContent;
    el.disabled = !!busy;
    el.textContent = busy ? (label || 'Verificando...') : el._defaultText;
    el.classList.toggle('is-loading', !!busy);
  }

  function setConnection(status, message) {
    ['db-status-login', 'db-status-portal'].forEach(function (id) {
      var el = $(id);
      if (!el) return;
      var text = el.querySelector('span:last-child');
      el.classList.remove('checking', 'on', 'off');
      el.classList.add(status);
      if (text) text.textContent = message;
    });
  }

  function api(action, payload) {
    if (!API_URL || API_URL.indexOf('PEGA_AQUI') !== -1) {
      return Promise.reject(new Error('Falta configurar API_URL en assets/carga.js'));
    }

    return fetch(API_URL, {
      method: 'POST',
      redirect: 'follow',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(Object.assign({ action: action }, payload || {}))
    }).then(function (response) {
      return response.json();
    });
  }

  function toast(message) {
    var el = $('aseo-toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('show');
    clearTimeout(el._timer);
    el._timer = setTimeout(function () {
      el.classList.remove('show');
    }, 2200);
  }

  function openModal(id) {
    var modal = $(id);
    if (modal) modal.classList.add('open');
  }

  function closeModal(id) {
    var modal = $(id);
    if (modal) modal.classList.remove('open');
  }

  function showLogin() {
    $('aseo-app').style.display = 'none';
    $('aseo-login').classList.add('show');
    $('lg-err').textContent = '';
    if (!$('lg-user').value) $('lg-user').value = 'Lienzo Centro';
    $('lg-pwd').value = '';
  }

  function showPortal() {
    $('aseo-login').classList.remove('show');
    $('aseo-app').style.display = '';
    $('portal-user').textContent = session && session.username ? session.username : 'Acceso autorizado.';
    renderButtons();
  }

  function loadButtons() {
    setConnection('checking', 'Verificando conexion');
    return api('portalBootstrap', {}).then(function (data) {
      if (!data.ok) throw new Error(data.error || 'No se pudo cargar el portal');
      setConnection('on', 'Conectado al servidor');
      buttons = normalizeButtons(data.buttons);
      applySettings(data.settings);
      renderButtons();
      if (!settings.lockEnabled) {
        session = { username: 'Lienzo Centro', token: 'sin-bloqueo' };
        showPortal();
      }
    }).catch(function (error) {
      buttons = DEFAULT_BUTTONS.slice();
      renderButtons();
      setConnection('off', 'Sin conexion con la base de datos');
      $('lg-err').textContent = error.message || 'Error de conexion con el servidor.';
    });
  }

  function doLogin() {
    var username = $('lg-user').value.trim();
    var password = $('lg-pwd').value;
    $('lg-err').textContent = '';
    setButtonBusy('btn-login', true, 'Verificando...');

    api('portalAuth', { username: username, password: password }).then(function (data) {
      setConnection('on', 'Conectado al servidor');
      if (!data.ok) {
        $('lg-err').textContent = data.error || 'Usuario o contrasena incorrectos.';
        return;
      }

      session = {
        username: data.user && data.user.usuario ? data.user.usuario : username,
        token: data.token || ''
      };
      buttons = normalizeButtons(data.buttons);
      applySettings(data.settings);
      $('lg-err').textContent = '';
      showPortal();
    }).catch(function () {
      setConnection('off', 'Sin conexion con la base de datos');
      $('lg-err').textContent = 'Error de conexion. Revisa la URL del Web App.';
    }).finally(function () {
      setButtonBusy('btn-login', false);
    });
  }

  function logout() {
    session = null;
    adminMaster = '';
    showLogin();
    toast('Sesion cerrada');
  }

  function renderButtons() {
    var box = $('portal-links');
    if (!box) return;
    var source = normalizeButtons(buttons);
    box.innerHTML = source.map(function (button) {
      return '<button class="portal-link" type="button" data-url="' + esc(button.url) + '">' + esc(button.label) + '</button>';
    }).join('');
  }

  function normalizeButtons(source) {
    if (!Array.isArray(source) || !source.length) return DEFAULT_BUTTONS.slice();
    return source.filter(function (button) {
      return button && button.label && button.url;
    }).map(function (button) {
      return {
        id: String(button.id || ''),
        label: String(button.label || ''),
        url: String(button.url || '')
      };
    });
  }

  function goToUrl(url) {
    if (!url) return;
    window.location.href = url;
  }

  function openAdminGate() {
    $('admin-master').value = '';
    $('admin-gate-err').textContent = '';
    openModal('modal-admin-gate');
    setTimeout(function () { $('admin-master').focus(); }, 40);
  }

  function unlockAdmin() {
    var master = $('admin-master').value;
    $('admin-gate-err').textContent = '';
    setButtonBusy('btn-unlock-admin', true, 'Verificando...');

    api('portalAdmin', { masterPassword: master }).then(function (data) {
      setConnection('on', 'Conectado al servidor');
      if (!data.ok) {
        $('admin-gate-err').textContent = data.error || 'Contrasena maestra incorrecta.';
        return;
      }

      adminMaster = master;
      adminUsers = data.users || [];
      adminButtons = data.buttons || [];
      buttons = adminButtons.slice();
      applySettings(data.settings);
      renderButtons();
      renderAdmin();
      closeModal('modal-admin-gate');
      openModal('modal-admin');
    }).catch(function () {
      setConnection('off', 'Sin conexion con la base de datos');
      $('admin-gate-err').textContent = 'Error de conexion con el servidor.';
    }).finally(function () {
      setButtonBusy('btn-unlock-admin', false);
    });
  }

  function renderAdmin() {
    var lockInput = $('lock-enabled');
    var lockText = $('lock-state-text');
    if (lockInput) lockInput.checked = !!settings.lockEnabled;
    if (lockText) lockText.textContent = settings.lockEnabled ? 'Activo' : 'Desactivado';

    $('admin-users').innerHTML = adminUsers.map(function (user) {
      return '<div class="admin-item">' +
        '<div><b>' + esc(user.usuario) + '</b></div>' +
        '<button class="btn btn-sm btn-outline" type="button" data-action="edit-user" data-user="' + esc(user.usuario) + '">Editar</button>' +
        '<button class="btn btn-sm btn-danger" type="button" data-action="delete-user" data-user="' + esc(user.usuario) + '">Eliminar</button>' +
      '</div>';
    }).join('');

    $('admin-buttons').innerHTML = adminButtons.map(function (button) {
      return '<div class="admin-item">' +
        '<div><b>' + esc(button.label) + '</b><span>' + esc(button.url) + '</span></div>' +
        '<button class="btn btn-sm btn-outline" type="button" data-action="edit-button" data-id="' + esc(button.id) + '">Editar</button>' +
        '<button class="btn btn-sm btn-danger" type="button" data-action="delete-button" data-id="' + esc(button.id) + '">Eliminar</button>' +
      '</div>';
    }).join('');
  }

  function normalizeSettings(source) {
    var next = { lockEnabled: true };
    if (source && Object.prototype.hasOwnProperty.call(source, 'lockEnabled')) {
      next.lockEnabled = source.lockEnabled === true || source.lockEnabled === 'true';
    }
    return next;
  }

  function applySettings(source) {
    settings = normalizeSettings(source || settings);
    var lockInput = $('lock-enabled');
    var lockText = $('lock-state-text');
    if (lockInput) lockInput.checked = !!settings.lockEnabled;
    if (lockText) lockText.textContent = settings.lockEnabled ? 'Activo' : 'Desactivado';
  }

  function toggleLock() {
    var input = $('lock-enabled');
    var enabled = input ? !!input.checked : !settings.lockEnabled;
    $('settings-err').textContent = 'Guardando...';

    api('saveSetting', {
      masterPassword: adminMaster,
      key: 'lockEnabled',
      value: enabled ? 'true' : 'false'
    }).then(function (data) {
      setConnection('on', 'Conectado al servidor');
      if (!data.ok) {
        var error = data.error || 'No se pudo guardar el bloqueo.';
        if (/desconocida|unknown/i.test(error)) {
          error = 'El Apps Script publicado aun no tiene esta funcion. Actualiza carga.gs y vuelve a desplegar el Web App.';
        }
        $('settings-err').textContent = error;
        applySettings(settings);
        return;
      }
      applySettings(data.settings);
      $('settings-err').textContent = '';
      toast(enabled ? 'Bloqueo inicial activado' : 'Bloqueo inicial desactivado');
    }).catch(function () {
      setConnection('off', 'Sin conexion con la base de datos');
      $('settings-err').textContent = 'Error de conexion con el servidor.';
      applySettings(settings);
    });
  }

  function saveUser() {
    var username = $('user-name').value.trim();
    var password = $('user-pass').value;
    if (!username || !password) {
      $('user-err').textContent = 'Completa usuario y contrasena.';
      return;
    }

    $('user-err').textContent = 'Guardando...';
    api('saveUser', { masterPassword: adminMaster, username: username, password: password }).then(function (data) {
      if (!data.ok) {
        $('user-err').textContent = data.error || 'No se pudo guardar.';
        return;
      }
      adminUsers = data.users || [];
      $('user-name').value = '';
      $('user-pass').value = '';
      $('user-err').textContent = '';
      renderAdmin();
      toast('Usuario guardado');
    }).catch(function () {
      $('user-err').textContent = 'Error de conexion con el servidor.';
    });
  }

  function editUser(username) {
    $('user-name').value = username;
    $('user-pass').value = '';
    $('user-pass').focus();
  }

  function deleteUser(username) {
    $('user-err').textContent = 'Eliminando...';
    api('deleteUser', { masterPassword: adminMaster, username: username }).then(function (data) {
      if (!data.ok) {
        $('user-err').textContent = data.error || 'No se pudo eliminar.';
        return;
      }
      adminUsers = data.users || [];
      $('user-err').textContent = '';
      renderAdmin();
      toast('Usuario eliminado');
    }).catch(function () {
      $('user-err').textContent = 'Error de conexion con el servidor.';
    });
  }

  function saveButton() {
    var id = $('button-id').value;
    var label = $('button-label').value.trim();
    var url = $('button-url').value.trim();
    if (!label || !url) {
      $('button-err').textContent = 'Completa texto y link.';
      return;
    }

    $('button-err').textContent = 'Guardando...';
    api('saveButton', { masterPassword: adminMaster, id: id, label: label, url: url }).then(function (data) {
      if (!data.ok) {
        $('button-err').textContent = data.error || 'No se pudo guardar.';
        return;
      }
      adminButtons = data.buttons || [];
      buttons = adminButtons.slice();
      clearButtonForm();
      renderButtons();
      renderAdmin();
      toast('Boton guardado');
    }).catch(function () {
      $('button-err').textContent = 'Error de conexion con el servidor.';
    });
  }

  function editButton(id) {
    var button = adminButtons.filter(function (item) { return item.id === id; })[0];
    if (!button) return;
    $('button-id').value = button.id;
    $('button-label').value = button.label;
    $('button-url').value = button.url;
  }

  function deleteButton(id) {
    $('button-err').textContent = 'Eliminando...';
    api('deleteButton', { masterPassword: adminMaster, id: id }).then(function (data) {
      if (!data.ok) {
        $('button-err').textContent = data.error || 'No se pudo eliminar.';
        return;
      }
      adminButtons = data.buttons || [];
      buttons = adminButtons.slice();
      clearButtonForm();
      renderButtons();
      renderAdmin();
      toast('Boton eliminado');
    }).catch(function () {
      $('button-err').textContent = 'Error de conexion con el servidor.';
    });
  }

  function clearButtonForm() {
    $('button-id').value = '';
    $('button-label').value = '';
    $('button-url').value = '';
    $('button-err').textContent = '';
  }

  function init() {
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        document.querySelectorAll('.modal-overlay.open').forEach(function (modal) {
          modal.classList.remove('open');
        });
      }
    });

    $('lg-pwd').addEventListener('keydown', function (event) {
      if (event.key === 'Enter') doLogin();
    });
    $('lg-user').addEventListener('keydown', function (event) {
      if (event.key === 'Enter') doLogin();
    });
    $('admin-master').addEventListener('keydown', function (event) {
      if (event.key === 'Enter') unlockAdmin();
    });

    bind('btn-login', 'click', doLogin);
    bind('btn-logout', 'click', logout);
    bind('btn-unlock-admin', 'click', unlockAdmin);
    bind('btn-save-user', 'click', saveUser);
    bind('btn-save-button', 'click', saveButton);
    bind('btn-clear-button-form', 'click', clearButtonForm);
    bind('lock-enabled', 'change', toggleLock);
    bind('btn-close-admin-gate', 'click', function () { closeModal('modal-admin-gate'); });
    bind('btn-close-admin', 'click', function () { closeModal('modal-admin'); });

    var adminButton = document.querySelector('.admin-stealth');
    if (adminButton) adminButton.addEventListener('click', openAdminGate);

    ['modal-admin-gate', 'modal-admin'].forEach(function (id) {
      var modal = $(id);
      if (!modal) return;
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal(id);
      });
    });

    function adminListClick(event) {
      var trigger = event.target.closest && event.target.closest('[data-action]');
      if (!trigger) return;

      var action = trigger.getAttribute('data-action');
      if (action === 'edit-user') editUser(trigger.getAttribute('data-user'));
      if (action === 'delete-user') deleteUser(trigger.getAttribute('data-user'));
      if (action === 'edit-button') editButton(trigger.getAttribute('data-id'));
      if (action === 'delete-button') deleteButton(trigger.getAttribute('data-id'));
    }
    bind('admin-users', 'click', adminListClick);
    bind('admin-buttons', 'click', adminListClick);
    bind('portal-links', 'click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-url]');
      if (!trigger) return;
      goToUrl(trigger.getAttribute('data-url'));
    });

    showLogin();
    loadButtons();
  }

  window.A = {
    doLogin: doLogin,
    logout: logout,
    openAdminGate: openAdminGate,
    unlockAdmin: unlockAdmin,
    saveUser: saveUser,
    editUser: editUser,
    deleteUser: deleteUser,
    saveButton: saveButton,
    editButton: editButton,
    deleteButton: deleteButton,
    clearButtonForm: clearButtonForm,
    openModal: openModal,
    closeModal: closeModal
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
